exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".switchButton__switch___3hfQg {\n  margin-top: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start; }\n  @media screen and (max-width: 1198px) {\n    .switchButton__switch___3hfQg {\n      margin-top: 0; } }\n  .switchButton__switch___3hfQg .switchButton__switchButton___2zVIU {\n    margin-top: 6px;\n    margin-left: 15px; }\n  .switchButton__switch___3hfQg > span {\n    display: inline-block; }\n", ""]);

// exports
exports.locals = {
	"switch": "switchButton__switch___3hfQg",
	"switchButton": "switchButton__switchButton___2zVIU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/SwitchButton/switchButton.scss
// module id = 2190
// module chunks = 6